module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    staticClass: "notice flexcenter"
  }, [_c('div', {
    staticClass: "notice-dialog flexcenter"
  }, [(_vm.isDocomo(_vm.platformName) || _vm.isAu(_vm.platformName)) ? _c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lbold font16"
  }, [_c('p', [_vm._v("音声が認識できない場合、以下を確認してください。")]), _vm._v(" "), _c('p', [_vm._v("1.設定で音声認識が有効になっているか確認してください。無効の場合は有効にしてください。")]), _vm._v(" "), _c('p', [_vm._v("2.音声認識が有効にできない場合、最新版にアップデートしてください。")])]), _vm._v(" "), _c('div', {
    staticClass: "flexcenter buttons"
  }, [(_vm.isDocomo(_vm.platformName)) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "dcmstore://launch?url=http%3A%2F%2Fapps.dmkt-sp.jp%2FSpApps%2FdetailApp%3Fdcmstore_view%3Dnone%26cId%3D10000022806",
      "target": "_blank"
    }
  }, [_vm._v("アップデートページへ")])]) : (_vm.isAu(_vm.platformName)) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showUpdatePage()
      }
    }
  }, [_vm._v("アップデートページへ")]) : (_vm.isLibraryAndroid(_vm.platformName)) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "http://play.google.com/store/apps/details?id=com.sourcenext.android.rosettastone",
      "target": "_blank"
    }
  }, [_vm._v("アップデートページへ")])]) : (_vm.isPlatformiOS(_vm.platformName)) ? _c('div') : _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("OK")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-48f2cae0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-48f2cae0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notice.vue
// module id = 716
// module chunks = 1